//
//
//
//
//
//
//
//

import EXIF from 'exif-js'
import uiCrop from '@/component/uiCrop'

export default {
  props: {
    quality: {
      value: Number,
      default: 0.5
    },
    edit: {
      value: Boolean,
      default: false
    },
    maxSize: {
      value: Number,
      default: 51200
    }
  },
  components: {
    uiCrop,
  },
  data () {
    return {
      canvas: null,
      crop: {
        editing: false,
        panel: true,
        img: ''
      }
    }
  },
  methods: {
    getImg (img, file) {
      console.log('img...')
      this.$emit('getImg', img, file)
    },
    uploadImgChange ($event) {
      let file = $event.target.files[0]
      let that = this
      EXIF.getData(file, function () {
        if (that.edit) {
          that.rotateImg(file, this.exifdata.Orientation, that.cropImg)
        } else {
          that.rotateImg(file, this.exifdata.Orientation, that.compressImg)
        }
      })
    },
    compressImg (size) {
      // quality值越小，所绘制出的图像越模糊
      let base64 = this.canvas.toDataURL('image/jpeg', size <= this.maxSize ? 0 : this.quality)
      // 解析base64
      let arr = base64.split(',')
      let [mime, bstr] = [arr[0].match(/:(.*?);/)[1], atob(arr[1])]
      let n = bstr.length
      // 转化成blob
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      this.getImg(base64, new Blob([u8arr], { type: mime }))
    },
    compressBase64 (base64) {
      console.log('compressBase64...')
      let that = this
      let img = new Image()
      img.src = base64
      img.onload = function () {
        // 获取图片的尺寸w*h
        let w = this.width
        let h = this.height
        // 生成canvas
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        // 创建canvas属性节点
        let anw = document.createAttribute('width')
        let anh = document.createAttribute('height')
        anw.nodeValue = w
        anh.nodeValue = h
        canvas.setAttributeNode(anw)
        canvas.setAttributeNode(anh)
        ctx.drawImage(img, 0, 0, w, h)
        // quality值越小，所绘制出的图像越模糊
        let base64 = canvas.toDataURL('image/jpeg', that.quality)
        // 解析base64
        let arr = base64.split(',')
        let [mime, bstr] = [arr[0].match(/:(.*?);/)[1], atob(arr[1])]
        let n = bstr.length
        // 转化成blob
        let u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        that.crop.editing = false
        that.getImg(base64, new Blob([u8arr], { type: mime }))
      }
    },
    cropImg () {
      console.log('cropImg...')
      this.crop.img = this.canvas.toDataURL('image/jpeg', 1)
      this.crop.editing = true
    },
    handleGetUrl (url) {
      this.compressBase64(url)
    },
    rotateImg (file, Orientation, callback) {
      console.log('rotateImg...')
      let that = this
      let ready = new FileReader()
      ready.readAsDataURL(file)
      ready.onload = function () {
        let img = new Image()
        img.src = this.result
        img.onload = function () {
          // 获取图片的尺寸w*h
          let w = this.width
          let h = this.height
          // 生成canvas
          let canvas = document.createElement('canvas')
          let ctx = canvas.getContext('2d')
          // 创建canvas属性节点
          let anw = document.createAttribute('width')
          let anh = document.createAttribute('height')
          // drawImage的起点坐标（x,y),canvas宽高ctxw*ctxh,旋转角度angle
          let [x, y, ctxw, ctxh, angle] = [0, 0, w, h, 0]
          /*
          * Orientation的值对应图片的角度
          * 1或则undefined不需要处理
          * 3图片需要旋转180度
          * 6图片需要顺时针旋转90度
          * 8图片需要顺时针旋转270度
          * canvas生成图片需要canvas和图片的尺寸一致，否则生成的图片会被裁剪或多出像素
          * 图片以画布原点（0，0）为旋转中心，须满足图片渲染到画布，并旋转后，整个图片刚好落入画布可视区域
          * eg：旋转90度
          * 图片尺寸长*宽为w*h,渲染图片的起点（0，-h),画布长*宽为h*w
           */
          switch (Orientation) {
            case 8:
              angle = 3 * Math.PI / 2
              x = -w
              ctxw = h
              ctxh = w
              break
            case 3:
              angle = Math.PI
              x = -w
              y = -h
              break
            case 6:
              angle = Math.PI / 2
              y = -h
              ctxw = h
              ctxh = w
              break
            default:
          }
          anw.nodeValue = ctxw
          anh.nodeValue = ctxh
          canvas.setAttributeNode(anw)
          canvas.setAttributeNode(anh)
          ctx.rotate(angle)
          ctx.drawImage(img, x, y, w, h)
          that.canvas = canvas
          callback(file.size)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/uiUploadPhoto.vue